import React, { useEffect, useState } from 'react';

import {Select, Row, Col, Typography, Skeleton} from 'antd';
import { Dinheiro } from '../../Numeros/dinheiro';
import {useContas} from './useContas';

import './SelectConta.scss';

const {Option} = Select;
const {Title} = Typography;




const SelectConta = props => { 

    const {getApi, onChange, contaSelecionada}  = props;

    

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saldo, setSaldo] = useState(0);
    const [selecionado, setSelecionado] = useState()

    const {listaContas} = useContas(getApi);


    useEffect(()=>{

        const init = async() =>{ 

            setLoading(true);

            try{

                const {data} = await listaContas();
        
        
                const newOptions = [];
        
                data.forEach(conta=>{
                    let cor = "#237804";
                    if(conta.saldo < 0){
                        cor = "#d4380d"
                    }
                    newOptions.push(
                        <Option value={conta.id} key={conta.id} label={conta.nome} conta={conta} >
        
                            <Row>
                                <Col span={24}>
                                    <div style={{
                                           
                                    
                                    }}>
                                        <span>
                                            {conta.nome}
                                        </span>
                                        <span style={{float: "right"}}>
                                            <Dinheiro value={conta.saldo}></Dinheiro>                                               

                                        </span>
                                    </div>                            
                                </Col>
                                
                            </Row>
                        </Option>
                    );
                });

                if(data.length){
                    if(contaSelecionada){
                        const contasEncontradas = data.find(conta => conta.id == contaSelecionada);
                        if(contasEncontradas){
                            defineSelecionado(contasEncontradas);    
                        }
                        else {
                            defineSelecionado(data[0]);
                        }
                    } else {
                        defineSelecionado(data[0]);
                    }
                }
        
                setOptions(newOptions);
            } catch(err){
                console.log("Houve um erro ao buscar as contas", err);
            } finally{
                setLoading(false);
            }
        }

        init();

    }, [])


    const defineSelecionado = (selecionado) => {
        const {saldo, id} = selecionado;
        setSaldo(saldo);
        setSelecionado(id);
        onChange && onChange(id);
    }

    const onChangeHandle = (value, opt) => {
        const {conta} = opt;
        defineSelecionado(conta);
        
    }


    return (
        <Skeleton title={false} paragraph={{rows: 3}}  loading={loading}>
            
                <Row style={{padding: "10px"}}>

                    <Col span={24}  style={{
                        padding:"0 12px"
                    }}>
                        <span style={{
                            float:"right",
                            textTransform: "uppercase",
                            fontSize: "0.8em"
                        }}>
                            Conta
                        </span>
                    </Col>
                    <Col span={24} style={{fontWeight: "bold", textAlign: "right"}}>
                        <Select optionLabelProp="label" value={selecionado} onChange={onChangeHandle} style={{ width: "200px", float: "right" }} size={"large"} placeholder="Selecione uma opção" bordered={false}>
                            {options}
                        </Select>
                    </Col>
                    <Col span={24} style={{
                        padding:"0 12px"
                    }}>
                            <span style={{float:"right", fontSize: "1.2em", color: (saldo<0)? "#d4380d": "#096dd9"}}>
                                <Dinheiro value={saldo}></Dinheiro>
                            </span>
                    </Col>
                </Row>

        </Skeleton>
            
        
    );
};

export {SelectConta};